import { render } from "./Flag.vue?vue&type=template&id=5518118f&scoped=true"
import script from "./Flag.vue?vue&type=script&lang=js"
export * from "./Flag.vue?vue&type=script&lang=js"

import "./Flag.vue?vue&type=style&index=0&id=5518118f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5518118f"]])

export default __exports__